import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import RelaxModel from "Base/model/RelaxModel";

export default class BasePaytableSettingContainer  extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
        this.addActions();
    }

    init() {
        this.soundToggle = this.getChildByName('soundToggle');
        this.infoScreenToggle = this.getChildByName('infoScreenToggle');
        this.quickSpinToggle = this.getChildByName('quickSpinToggle');

        this.soundToggle.checked = !EntryPoint.GameSettings.soundMute;
        this.infoScreenToggle.checked = EntryPoint.GameSettings.introScreen;
        this.quickSpinToggle.checked = EntryPoint.GameSettings.quickSpin;

        this.soundToggle.enabled = true;
        this.infoScreenToggle.enabled = true;
        this.quickSpinToggle.enabled = true;

        this.quickSpinToggle.visible = RelaxModel.availableFastSpin;
        this.getChildByName('label_settings_cb_quick_spin').visible = RelaxModel.availableFastSpin;
    }

    addListeners() {
        GlobalDispatcher.add('gameSettings:soundMute', this.onSoundMute, this);
        GlobalDispatcher.add('gameSettings:quickSpin', this.onQuickSpin, this);
    }

    addActions() {
        this.soundToggle.actions = {
            checked: {
                callback: this.onSoundToggle, context: this, params: false
            },
            unchecked: {
                callback: this.onSoundToggle, context: this, params: true
            }
        };
        this.infoScreenToggle.actions = {
            checked: {
                callback: this.onInfoScreenToggle, context: this, params: true
            },
            unchecked: {
                callback: this.onInfoScreenToggle, context: this, params: false
            }
        };
        this.quickSpinToggle.actions = {
            checked: {
                callback: this.onQuickSpinToggle, context: this, params: true
            },
            unchecked: {
                callback: this.onQuickSpinToggle, context: this, params: false
            }
        };
    }

    onSoundMute(event) {
        this.soundToggle.checked = !event.params;
    }

    onQuickSpin(event) {
        this.quickSpinToggle.checked = event.params;
    }

    onSoundToggle(data) {
        EntryPoint.GameSettings.soundMute = data;
        EntryPoint.GameSettings.musicMute = data;
    }

    onInfoScreenToggle(data) {
        EntryPoint.GameSettings.introScreen = data;
    }

    onQuickSpinToggle(data) {
        EntryPoint.GameSettings.quickSpin = data;
    }

    destroy(options) {
        GlobalDispatcher.remove('gameSettings:soundMute', this.onSoundMute, this);
        GlobalDispatcher.remove('gameSettings:quickSpin', this.onQuickSpin, this);
        super.destroy(options);
    }
}